import { useEffect, useRef } from 'react';
import { bindBackButton } from './telegram';

/** Системная кнопка «Назад» Telegram, пока экран открыт. */
export function useBackButton(onBack: () => void): void {
  const ref = useRef(onBack);
  ref.current = onBack;
  useEffect(() => bindBackButton(() => ref.current()), []);
}
